// import PropTypes from 'prop-types';
import styles from './FormTextAreaField.module.scss';

const FormTextAreaField = ({ placeholder, label, register, type, name, errors, helptext, rows = 3 }) => {
    return (
        <div className={styles['FormTextAreaField']}>
            <label
                htmlFor={name}
                className={styles['FormTextAreaField__Label']}
            >
                {label}
                <textarea
                    id={name}
                    type={type}
                    name={name}
                    rows={rows}
                    {...register}
                    placeholder={placeholder}
                    className={styles['FormTextAreaField__Field']}
                />
            </label>
            {helptext && (
                <p className={styles['FormTextAreaField__HelpText']}>{helptext}</p>
            )}
            {errors && errors[name]?.type === "required" && (
                <span className={styles['FormTextAreaField__Error']}>
                    This field is required
                </span>
            )}
        </div>
    );
};

FormTextAreaField.propTypes = {};

export default FormTextAreaField;
